export const ACCOUNT_FILTER_ACTIVE = 'show-account-filter';
